import { authGet } from "@api/auth/auth";
import { ScanResponse } from "@types";

const SCAN_URL = `/api/agent/scans`;

export const fetchScan = (scanId: number): Promise<ScanResponse> => {
  const url = `${SCAN_URL}/${scanId}`;
  return authGet<ScanResponse>(url);
};
